import { it } from 'date-fns/locale';
import { LocaleDefinition } from '../localeDefinition';
import messages from './it.json';

const definition: LocaleDefinition = {
  code: 'it-IT',
  messages,
  dateFnsLocale: it,
};

export default definition;
